import React from 'react';
import { getUILoc } from '../../utils/cardUtils.js';

const RulesOverlay = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const rules = {
    title: getUILoc('RULES.TITLE'),
    intro: getUILoc('RULES.INTRO'),
    victory: getUILoc('RULES.VICTORY_CONDITIONS'),
    flow: getUILoc('RULES.GAME_FLOW'),
    types: getUILoc('RULES.CARD_TYPES'),
    keywords: getUILoc('RULES.KEYWORDS'),
    other: getUILoc('RULES.OTHER')
  };

  return (
    <div className="overlay" onClick={handleOverlayClick}>
      <div className="overlay-modal rules-overlay">
        <div className="overlay-header">
          <h2>{rules.title}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="overlay-content">
          <div className="rules-content-structured">
            <p className="rules-intro">{rules.intro}</p>
            
            <section>
              <h3>{rules.victory.TITLE}</h3>
              <p>{rules.victory.BODY}</p>
              <pre className="rules-subtext">{rules.victory.WIN}</pre>
              <pre className="rules-subtext">{rules.victory.LOSE}</pre>
              <p className="rules-note">{rules.victory.DRAW_NOTE}</p>
            </section>

            <section>
              <h3>{rules.flow.TITLE}</h3>
              <pre className="rules-subtext">{rules.flow.SETUP}</pre>
              <pre className="rules-subtext">{rules.flow.FLOW}</pre>
              <p className="rules-note">{rules.flow.ORDER_NOTE}</p>
            </section>

            <section>
              <h3>{rules.types.TITLE}</h3>
              <p>{rules.types.WEALTH}</p>
              <p>{rules.types.EVENT}</p>
              <p>{rules.types.IDEOLOGY}</p>
            </section>

            <section>
              <h3>{rules.keywords.TITLE}</h3>
              <p>{rules.keywords.DRAW}</p>
              <p>{rules.keywords.EXPOSE}</p>
              <p>{rules.keywords.REVENGE}</p>
              <p>{rules.keywords.DISCARD}</p>
              <p>{rules.keywords.AUTO_PLACE}</p>
            </section>

            <section>
              <h3>{rules.other.TITLE}</h3>
              <p>{rules.other.SCALE_MIN}</p>
              <p className="rules-footer">{rules.other.FOOTER}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RulesOverlay;